import styled from 'styled-components';

import HeroHeading from 'components/hero-heading';

export const StyledHeroHeading = styled(HeroHeading)`
  color: ${p => p.theme.token('text-reversed')};
  text-shadow: none;
  font-weight: normal;
  font-size: 5rem;
  font-family: ${Styles.fontFamily.alternative};
  text-shadow: 0px 3px 7px rgb(80, 35, 20);

  ${Styles.desktop`
    font-size: 10rem;
    margin: 0;
  `};
`;
